import React from "react";

import Richtext from "@dip/helsecore/src/components/shared/Wrappers/Richtext";
import { Heading } from "@dip/helsecore/src/components/shared/Heading/Heading";

type KapittelContent = {
  _id: string; // / Enonic id
  title?: string;
  preface?: string;
  text?: string;
  children?: KapittelContent[];
};

type KapittelPDFProps = {
  content: KapittelContent;
  chapterNumber: number
  chapterPrefix?: string;
  isChild?: boolean;
};

export default function KapittelPDF({
  content,
  chapterNumber,
  chapterPrefix,
  isChild = false
}: Readonly<KapittelPDFProps>) {
  const resolvedChapterNumber = (chapterPrefix)
    ? `${chapterPrefix}.${chapterNumber}`
    : `${chapterNumber}`;

  return (
    <li className="print-page-break">
      <div className="b-chapter-heading b-chapter-heading--line-none">
        {content.title && <Heading headingLevel={isChild ? "h3" : "h2"}>{`${resolvedChapterNumber} ${content.title}`}</Heading>}
      </div>
      <div className="flex flex-col gap-sm">
        {content.preface && <p className="t-body-text">{content.preface}</p>}
        {content.text && <Richtext className="t-body-text" text={content.text} />}
      </div>

      {content.children?.length ? (
        <ul className="list-none p-0">
          {content.children.map((child, childIndex) => (
            <KapittelPDF
              key={`${resolvedChapterNumber}-${child.title}`}
              content={child}
              chapterNumber={childIndex + 1}
              chapterPrefix={resolvedChapterNumber}
              isChild
            />
          ))}
        </ul>
      ) : null}
    </li>
  );
}
